"use client";

import { CardSupplierProps } from "@/types";
import { buildAvatarSrc } from "@/utils/buildAvatarSrc";
import { formatCurrency } from "@/utils/formatCurrency";
import { formatarTelefoneMundial } from "@/utils/formatarTelefoneMundial";
import {
  Building2,
  Mail,
  Map,
  Package,
  Pencil,
  PhoneCall,
  Trash,
} from "lucide-react";
import React from "react";
import ButtonIcon from "../buttonIcon";
import Start from "../start";
import * as S from "./styles";

const CardSupplier: React.FC<CardSupplierProps> = ({
  className,
  data,
  handleUpdate,
  handleRemove,
  cantEdit,
  cantDelete,
  currency,
}) => {
  return (
    <>
      {data.map((item, index: number) => {
        const avatar =
          buildAvatarSrc({
            avatar_url: (item as any).avatar_url,
            avatar_path: (item as any).avatar_path,
          }) || (item as any).image;
        return (
          <S.CardService className={className} key={item.id}>
            <S.BoxBody>
              <S.HeaderCard>
                {avatar && (
                  <S.ImageEmployee as="img" src={avatar} alt={item.name} />
                )}
                <S.InfoHeader>
                  <S.TitleCard>{item.name}</S.TitleCard>
                  <S.BoxCategoryStart>
                    <S.TypeCategory>{item.profession}</S.TypeCategory>
                    <Start score={item.score} />
                  </S.BoxCategoryStart>
                </S.InfoHeader>
              </S.HeaderCard>
              <S.BoxAlign>
                <S.Control>
                  <S.TitleControl>Total de Pedidos</S.TitleControl>
                  <S.Value>{item.totalOrders || 0}</S.Value>
                </S.Control>
                <S.Control>
                  <S.TitleControl>Total Gasto</S.TitleControl>
                  <S.Value>
                    {formatCurrency(Number(item.totalSpent) || 0, currency)}
                  </S.Value>
                </S.Control>
              </S.BoxAlign>
              <S.BodyCard>
                <S.ListItemEMployees>
                  {item.owner && item.owner !== "-" && (
                    <S.ItemEmployee>
                      <Building2 />
                      <span>{item.owner}</span>
                    </S.ItemEmployee>
                  )}
                  {item.phone && item.phone !== "-" && (
                    <S.ItemEmployee>
                      <PhoneCall />
                      <span>{formatarTelefoneMundial(item.phone)}</span>
                    </S.ItemEmployee>
                  )}
                  {item.address && item.address !== "-" && (
                    <S.ItemEmployee>
                      <Map />
                      <span>{item.address}</span>
                    </S.ItemEmployee>
                  )}
                  {item.pix_key && item.pix_key !== "-" && (
                    <S.ItemEmployee>
                      <Mail />
                      <span>{item.pix_key}</span>
                    </S.ItemEmployee>
                  )}
                  <S.ItemEmployee>
                    <Package />
                    <span>Último pedido: {item.lastOrder || "-"}</span>
                  </S.ItemEmployee>
                </S.ListItemEMployees>
              </S.BodyCard>
            </S.BoxBody>
            <S.FooterCard>
              {cantEdit && (
                <ButtonIcon
                  icon={<Pencil />}
                  hovercolor="green"
                  onClick={() => handleUpdate(Number(item.id))}
                />
              )}
              {cantDelete && (
                <ButtonIcon
                  icon={<Trash />}
                  hovercolor="red"
                  onClick={() => handleRemove(Number(item.id))}
                />
              )}
            </S.FooterCard>
          </S.CardService>
        );
      })}
    </>
  );
};

export default CardSupplier;
